import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import "./ModalComponent.scss"

Modal.setAppElement('#root');

// Конфигурации стилей
const CUSTOM_STYLES = {
  default: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      borderRadius: 0,
    },
    overlay: {
      background: '#00000026',
    }
  },
  sidebar: {
    content: {
      top: '0',
      left: 'auto',
      right: '-100%',
      bottom: '0',
      border: 'none',
      borderRadius: 0,
    },
    overlay: {
      background: '#00000026',
      justifyContent: 'flex-end',
    }
  },
  specialists: {
    content: {
      width: '469px',
      top: '0',
      left: 'auto',
      right: '-100%',
      bottom: '0',
      border: 'none',
      borderRadius: 0,
    },
    overlay: {
      background: '#00000026',
      justifyContent: 'flex-end',
    }
  }
};

// Классы для разных типов модальных окон
const MODAL_CLASSES = {
  record: '',
  form: '',
  slots: 'modal__inner--slots',
  specialist: 'modal__inner--specialist',
  sidebar: ''
};

const ModalComponent = ({
  sidebar = false,
  openHandler = null,
  closeHandler = null,
  afterOpenHandler = null,
  afterCloseHandler = null,
  button,
  children,
  isOpen = null,
  isRecordModal = false,
  isFormModal = false,
  isSpecialistListModal = false,
  isSlotsForm = false
}) => {
  const [modalIsOpen, setIsOpen] = useState(isOpen ?? false);
  const nodeRef = useRef();

  // Определяем стили и тип модального окна
  const modalType = isSpecialistListModal ? 'specialists' : sidebar ? 'sidebar' : 'default';
  const customStyles = CUSTOM_STYLES[modalType];
  const modalClassName = sidebar ? "Modal--sidebar" : "Modal--center";

  // Определяем, нужно ли показывать кнопку collapse
  const showCollapseButton = isRecordModal;

  // Обработчики
  const openModal = () => {
    setIsOpen(true);
    openHandler?.();
  };

  const closeModal = (collapseFlag = false) => {
    setIsOpen(false);
    closeHandler?.(collapseFlag);
  };

  const afterOpenModal = () => afterOpenHandler?.();
  const afterCloseModal = () => afterCloseHandler?.();
  const collapseModal = () => closeModal(true);

  // Эффект для синхронизации с внешним isOpen
  useEffect(() => {
    if (isOpen !== null) {
      setIsOpen(isOpen);
    }
  }, [isOpen]);

  // Определяем, какой тип контента показывать
  const getModalContent = () => {
    const baseClass = 'modal__inner';
    let additionalClass = '';
    
    if (isSlotsForm) additionalClass = MODAL_CLASSES.slots;
    else if (isSpecialistListModal) additionalClass = MODAL_CLASSES.specialist;
    
    const className = `${baseClass} ${additionalClass}`.trim();

    return (
      <div className={className} ref={nodeRef}>
        <button className="modal__close" onClick={closeModal} aria-label="Close modal" />
        {showCollapseButton && (
          <button className="modal__collapse" onClick={collapseModal} aria-label="Collapse modal" />
        )}
        {children}
      </div>
    );
  };

  const bodyStyles = `
    .ReactModal__Body--open{
      overflow: hidden !important;
      padding-right: 2px;
    }
  `;

  return (
    <div className="modal">
      <button onClick={openModal} type="button">
        {button}
      </button>
      
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onAfterClose={afterCloseModal}
        onRequestClose={closeModal}
        style={customStyles}
        shouldCloseOnOverlayClick={true}
        className={modalClassName}
      >
        {getModalContent()}
        {sidebar && <style>{bodyStyles}</style>}
      </Modal>
    </div>
  );
};

export default ModalComponent;